import { render, staticRenderFns } from "./CourseVideoThumb20.vue?vue&type=template&id=9c9e72e2&scoped=true"
import script from "./CourseVideoThumb20.vue?vue&type=script&lang=js"
export * from "./CourseVideoThumb20.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoThumb20.vue?vue&type=style&index=0&id=9c9e72e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9e72e2",
  null
  
)

export default component.exports